import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
} from '@angular/core';
import { StepAction } from '../../../../workflow.model';
import { RequestActionEnum } from '../../../../../../../common/enums/request-action.enum';

@Directive({
  selector: '[libStepActionValue]',
})
export class StepActionValueDirective implements AfterViewInit {
  private readonly el = inject(ElementRef);

  requestActionsEnum = RequestActionEnum;
  action = input.required<string>();
  actionList = input.required<StepAction[]>();
  successClass = 'text-success-500';
  destructiveClass = 'text-destructive-500';
  enabledLabel = input<string>('Yes');
  disabledLabel = input<string>('No');

  getActionValue() {
    return (
      this.actionList().find(action => action.value === this.action())
        ?.preference ?? 0
    );
  }

  getActionClass() {
    return this.getActionValue() ? this.successClass : this.destructiveClass;
  }

  getActionLabel() {
    return this.getActionValue() ? this.enabledLabel() : this.disabledLabel();
  }

  ngAfterViewInit() {
    const div = this.el.nativeElement;
    div.textContent = this.getActionLabel();
    div.classList.add(this.getActionClass());
  }
}
